import React from 'react';
import { Link } from 'react-router-dom';

export const CtaSection = () => {
    return (
        <section style={{ padding: '160px 0', background: 'var(--bg-primary)', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', height: '80%', background: 'linear-gradient(135deg, var(--accent-primary) 0%, var(--accent-secondary) 100%)', filter: 'blur(200px)', opacity: 0.15, borderRadius: '50%', zIndex: 0 }}></div>

            <div className="container" style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: '800px' }}>
                <h2 style={{ fontSize: 'clamp(3rem, 6vw, 4.5rem)', fontWeight: 800, letterSpacing: '-0.02em', marginBottom: '32px', lineHeight: 1.1 }}>
                    Stop Losing Revenue at the Table.
                </h2>
                <p style={{ color: 'var(--text-secondary)', fontSize: '1.5rem', marginBottom: '56px', maxWidth: '600px', margin: '0 auto 56px auto' }}>
                    Modern hospitality starts here. Fast to deploy, intuitive to use, and focused entirely on your bottom line.
                </p>
                <Link to="/contact" className="btn btn-primary" style={{ padding: '24px 48px', fontSize: '1.25rem', borderRadius: '12px', boxShadow: '0 8px 32px var(--accent-glow)', textDecoration: 'none' }}>
                    Book Your Demo
                </Link>
            </div>
        </section>
    );
};
